import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    redirect: '/invoices',
    children: [
      {
        path: '/invoices',
        component: () => import('../views/Invoices.vue'),
      },
      {
        path: '/invoices/:invoiceId',
        component: () => import('../views/InvoiceDetail.vue'),
      },
      {
        path: '/products',
        component: () => import('../views/Products.vue'),
      },
      {
        path: '/profile',
        component: () => import('../views/Profile.vue'),
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import('../views/Signup.vue'),
  },
  {
    path: '/forgot',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue'),
  },
  {
    path: '/forgot/:token',
    name: 'ChangePassword',
    component: () => import('../views/ChangePassword.vue'),
  },
  {
    path: '/accept-invitation',
    name: 'AcceptInvitation',
    component: () => import('../views/AcceptInvitation.vue'),
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: () => import('../views/errors/404.vue'),
  },
  {
    path: '/:org',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '*',
    redirect: '/notfound',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isLoggedIn']) {
      next();
      return;
    }
    next('/notfound');
  } else {
    next();
  }
});
export default router;
